// src/constants/pbhREPAIR.constant.js

export const pbhRepairConstants = {
  PBH_REPAIRS_REQUEST: 'PBH_REPAIRS_REQUEST',
  PBH_REPAIRS_SUCCESS: 'PBH_REPAIRS_SUCCESS',
  PBH_REPAIRS_FAILURE: 'PBH_REPAIRS_FAILURE',

  PBH_REPAIR_DETAILS_REQUEST: 'PBH_REPAIR_DETAILS_REQUEST',
  PBH_REPAIR_DETAILS_SUCCESS: 'PBH_REPAIR_DETAILS_SUCCESS',
  PBH_REPAIR_DETAILS_FAILURE: 'PBH_REPAIR_DETAILS_FAILURE',

  PBH_REPAIRS_SEARCH_REQUEST: 'PBH_REPAIRS_SEARCH_REQUEST',
  PBH_REPAIRS_SEARCH_SUCCESS: 'PBH_REPAIRS_SEARCH_SUCCESS',
  PBH_REPAIRS_SEARCH_FAILURE: 'PBH_REPAIRS_SEARCH_FAILURE'
};